import {
  ISimpleUserInfoHolder,
  IStorageRepositoryProvider,
  T_ISimpleUserInfoHolder,
} from '@cgs/common';
import { Container } from '@cgs/wge';
import { IStorageService, STORAGE_SERVICE_TOKEN } from '@cgs/shared';
import { IGameParams } from '../../reels_engine/interfaces/i_game_params';
import { T_IGameParams } from '../../type_definitions';

export class ClientDataRepositoryProvider implements IStorageRepositoryProvider {
  private static readonly SearchPattern: string = 'USER_ID:GAME_ID:KEY';

  private _withGameId: boolean;
  private _withUserId: boolean;
  private _container: Container;
  private storageService: IStorageService;

  constructor(container: Container, withUserId: boolean = true, withGameId: boolean = true) {
    this.storageService = container.resolve<IStorageService>(STORAGE_SERVICE_TOKEN);
    this._container = container;
    this._withGameId = withGameId;
    this._withUserId = withUserId;
  }

  private get _userId(): string {
    return this._withUserId
      ? `${
          this._container.resolve<ISimpleUserInfoHolder>(T_ISimpleUserInfoHolder).user?.userId || ''
        }`
      : '';
  }

  private get _gameId(): string {
    return this._withGameId ? this._container.resolve<IGameParams>(T_IGameParams).gameId : '';
  }

  public createItem(key: string, value: string, isUpdateMode: boolean = true): void {
    this._validateKeyValue(key, value);
    if (this.readItem(key)) {
      if (isUpdateMode) {
        this.deleteItem(key);
      } else {
        throw new Error('such item is present');
      }
    }

    const fullKey = this._getFullKey(key);
    this.storageService.setItem(fullKey, value);
  }

  public readItem(key: string): string | null {
    return this.storageService.getItem(this._getFullKey(key));
  }

  public deleteItem(key: string): void {
    this.storageService.removeItem(this._getFullKey(key));
  }

  private _getFullKey(key: string): string {
    return ClientDataRepositoryProvider.SearchPattern.replace('USER_ID', this._userId)
      .replace('GAME_ID', this._gameId)
      .replace('KEY', key);
  }

  private _validateKeyValue(key: string, value: string): void {
    if (!key) {
      throw new Error('key is null or empty');
    }

    if (!value) {
      throw new Error('value is null or empty');
    }
  }
}
